import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import AuditedPerformanceHero from "./sections/AuditedPerformanceHero";
import CaseStudyDirectory from "./sections/CaseStudyDirectory";
import ConsultationCta from "./sections/ConsultationCta";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <AuditedPerformanceHero />
      <CaseStudyDirectory />
      <ConsultationCta />
      <Footer />
    </div>;
}